<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="PurchItemsTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :show_toolbar_state="true" :isBusy="isBusy"
        :hb_table_class="'hb_table_purch_items_class1'" :table_height_adjust="-8" :loading_width="40"
        @on_query="on_query" @state_change="state_change" @tool_invoke="tool_invoke" tableref="afdc98a2c3cc40cea716743d4a8f6963">
        <template #query>
          {{ $t("common.purch_order_num") }}：<el-input clearable size="small" style="width: 150px"
            v-model="PurchId"></el-input>
          {{ $t("common.provider") + $t("common.num") }}：<el-input clearable size="small" style="width: 150px"
            v-model="AccountNum"></el-input>
          {{ $t("common.provider") + $t("common.num") }}：<el-input clearable size="small" style="width: 200px"
            v-model="VendName"></el-input>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as PurchaseOrderItemsController from "../../controllers/mm/PurchaseOrderItemsController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"

export default {
  name: "PurchaseOrderItems",
  components: {
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_purch_order_detail",
      },
      fields: PurchaseOrderItemsController.fields.default,

      VendName: "",
      AccountNum: "",
      PurchId: "",
      isBusy: false,
      all_role_users: [],
    }
  },
  created() {
    this.getAllRoleUsers()
  },
  methods: {
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true
      let _fromDate = "",
        _toDate = ""
      let _params = {}
      if (this.VendName != "") {
        _params.VendName = this.VendName
      }
      if (this.AccountNum != "") {
        _params.AccountNum = this.AccountNum
      }
      if (this.PurchId != "") {
        _params.PurchId = this.PurchId
      }
      if (
        !_.isNull(date_range) &&
        this.AccountNum == "" &&
        this.PurchId == "" &&
        this.VendName == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
      }
      set_data([])
      let _result = await PurchaseOrderItemsController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          this.getApprover(t)
        })
        set_data(_.orderBy(_result[0], ["createdDateTime"], ["desc"]))
      }
      this.isBusy = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOApprover",
        "SOApprover",
        t.fcCheckSOApproved
      )
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOCreditControlApprover",
        "SOCreditControlApprover",
        t.fcCheckSOCreditControlApproved
      )
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOPriceDiffApprover",
        "SOPriceDiffApprover",
        t.fcCheckSOPriceDffApproved
      )
    },
    //#endregion

    //#region 状态切换
    // state_change(data, cb) {

    // },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: "table_sales_order_detail",
          sheet_title: "客户",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    //#endregion
  },
}
</script>
<style>
.hb_table_purch_items_class1 {
  /* width: auto; */
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 120rem;
}
</style>
